// this file was prevaled
module.exports={"name":"soapbox-fe","displayName":"Soapbox FE","url":"https://gitlab.com/soapbox-pub/soapbox-fe","repository":"soapbox-pub/soapbox-fe","version":"3.0.0-9ce9a3f","homepage":"https://soapbox.pub/"};